import { render, staticRenderFns } from "./c-property-user-defined-fields.vue?vue&type=template&id=2925020e&"
import script from "./c-property-user-defined-fields.vue?vue&type=script&lang=js&"
export * from "./c-property-user-defined-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports